import React from 'react'

interface AirspaceAlertProps {
    alertLabel: string
    message: string
    knowMoreText: string
    onKnowMore?: () => void
    isMobile?: boolean
}

const AirspaceAlert: React.FC<AirspaceAlertProps> = ({
    alertLabel,
    message,
    knowMoreText,
    onKnowMore,
    isMobile
}) => {
    return (
        <div
            style={{
                backgroundColor: '#FFF8C4',
                borderTop: '1.5px dashed #90CAF9',
                borderBottom: '1.5px dashed #90CAF9',
                padding: '12px 16px',
                margin: 0,
            }}
        >
            <p
                style={{
                    margin: 0,
                    fontSize: '14px',
                    lineHeight: '1.5',
                    color: '#1A1A1A',
                    fontFamily: 'inherit',
                    textAlign: isMobile ? 'start' : 'center',
                }}

            >
                <span style={{ fontWeight: 700 }}>{alertLabel}: </span>
                {message}
                <span
                    onClick={onKnowMore}
                    style={{
                        color: '#1976D2',
                        fontWeight: 500,
                        cursor: 'pointer',
                        marginLeft: '4px',
                        marginRight: '4px',
                    }}
                >
                    {knowMoreText}
                </span>
            </p>
        </div>
    )
}

export { AirspaceAlert }
export type { AirspaceAlertProps }
